
<top-banner variant="title" [title]="selectedContractor?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-card-tabs [tabitems]="tabitems"></app-card-tabs>
          </div>
          <div class="col-md-10">
            <h4 class="card-title">Details</h4>
            <div class="mb-2 animated fadeIn">
              <form [formGroup]="contractorDetailsForm" (ngSubmit)="onContractorDetailsFormSubmit()">
                <div class="form-row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Name</label>
                      <input type="text" class="form-control" formControlName="name">
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Description</label>
                      <textarea type="text" class="form-control" formControlName="description"></textarea>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Additional Information</label>
                      <textarea type="text" class="form-control with-autoresize" appTextareaAutoresize formControlName="additionalInfo"></textarea>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Address</label>
                      <input type="text" class="form-control" formControlName="address">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Primary Contact No.</label>
                      <input type="text" class="form-control" formControlName="mainContactNo">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group form-group-checkbox">
                      <label>OEM</label>
                      <p-checkbox class="form-control" formControlName="oem" binary="true"></p-checkbox>
                    </div>
                  </div>
                  <div class="col-md-6" *ngIf="contractorManagers.length">
                    <div class="form-group">
                      <label>Manager</label>
                      <p-dropdown
                          class="form-control"
                          [(ngModel)]="selectedManager"
                          (ngModelChange)="onSelectedManagerChange($event)"
                          [ngModelOptions]="{standalone: true}"
                          [options]="contractorManagers"
                          optionLabel="label"
                          [style]="{'width':'100%'}"
                          filter="true"></p-dropdown>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Manager Contact Number</label>
                      <input type="text" class="form-control" [value]="selectedContractor?.maintenanceManager?.phoneNumber || ''" readonly>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <button type="submit" class="btn btn-success btn-round">
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
